import { render, staticRenderFns } from "./UserC2View.vue?vue&type=template&id=e441dd7a&"
import script from "./UserC2View.vue?vue&type=script&lang=js&"
export * from "./UserC2View.vue?vue&type=script&lang=js&"
import style0 from "./UserC2View.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports